import axios from 'axios';
import { logger } from '../utils/logger';

// API 配置文件
const API_BASE_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 120000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    withCredentials: true // 启用跨域 cookie
});

// 請求攔截器
apiClient.interceptors.request.use(
    config => {
        //logger.log('=== Request Config ===');
        logger.log('URL:', config.baseURL + config.url);
        logger.debug('Headers:', config.headers);
        //logger.log('API请求发送:', config.url);
        
        // 确保请求包含 credentials
        config.withCredentials = true;
        
        return config;
    },
    error => {
        logger.error('=== API Error ===');
        logger.error('Config:', error.config);
        logger.error('API请求错误:', error);
        return Promise.reject(error);
    }
);

// 響應攔截器
apiClient.interceptors.response.use(
    response => {
        logger.log('=== API Response Status ===', response.status);
        //console.log('Headers:', response.headers);
        logger.debug('Data:', response.data);
        return response;
    },
    error => {
        logger.error('=== API Error ===');
        logger.error('Config:', error.config);
        logger.error('API响应错误:', error);
        if (error.response) {
            logger.error('状态码:', error.response.status);
            logger.error('响应数据:', error.response.data);
        } else if (error.request) {
            logger.error('无响应错误:', error.request);
        } else {
            logger.error('配置错误:', error.message);
        }
        return Promise.reject(error);
    }
);

export { apiClient };

// API端点配置
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  endpoints: {
    transcript: '/api/transcript',
    companySearch: '/api/companies/search',
    translate: '/api/translate',
    translateLibre: '/api/translate_libre',
    translateGoogle: '/api/translate_goo',
    companyYears: '/api/transcript/:symbol/years',
    companyCik: '/api/company-cik',
    latestTranscript: '/api/transcript/latest',
    metricRatio: '/api/financial/metric_ratio',
    itemsShow: '/api/items-show',
    watchlist: {
      add: '/api/users/watchlist/add',
      show: '/api/users/watchlist/show',
      remove: '/api/users/watchlist/remove',
      check: '/api/users/watchlist/check',
      list: '/api/users/watchlist/list'
    },
    USER_AUTH: {
      LOGIN: '/api/users/login',
      LOGOUT: '/api/users/logout',
      REFRESH_TOKEN: '/api/users/refresh-token',
      GET_USER: '/api/users/me',

      REGISTER: '/api/users/register',
      PROFILE: '/api/users/profile',
      RESET_PASSWORD: '/api/users/reset-password',
      RESEND_VERIFICATION: '/api/users/resend-verification'
    },
    // 添加筛选器相关API
    SCREENER: {
      FILTER: '/api/screener/filter',
      SECTORS: '/api/screener/sectors',
      INDUSTRIES: '/api/screener/industries',
      CHECK_VIEW_LIMIT: '/api/screener/check-view-limit'
    },
    // 添加顶级公司相关API
    TOPCOMPANIES: {
      TOP_MARKET_CAP: '/api/topcompanies/top-market-cap',
      TOP_SECTOR_MARKET_CAP: '/api/topcompanies/top-sector-market-cap',
      TOP_RISE: '/api/topcompanies/top-rise',
      TOP_DROP: '/api/topcompanies/top-drop',
      TOP_DIVIDEND_YIELD: '/api/topcompanies/top-dividend-yield',
      TOP_RISE_DATE: '/api/topcompanies/top-rise-date',
      TOP_PERF: '/api/topcompanies/top-perf',
      CHECK_VIEW_LIMIT: '/api/topcompanies/check-view-limit',
      MARKET_MOMENTUM: '/api/topcompanies/market-momentum'
    },
    // 添加技术面相关API
    TECHNICAL: {
      CANDLESTICK: '/api/technical/candlestick',
      INDICATORS: '/api/technical/indicators'
    },
    // 添加估值相关API
    VALUATION: {
      ESTIMATE: '/api/valuation/estimate',
      PE: '/api/valuation/pe',
      ESTIMATE_TARGET: '/api/valuation/estimate_target'
    },
    // 添加新闻稿相关API
    PRESS: {
      earningdate: '/api/press/earningdate'
    },
  },
  // 公司相关
  COMPANY_INFO: (symbol) => `/api/company/${symbol}`,
  COMPANY: (symbol) => `/api/company/${symbol}`,
  
  // 财务报表相关
  FINANCIAL: {
    INCOME: (symbol, period = 'FY') => `/api/financial/income/${symbol}?period=${period}`,
    BALANCE: (symbol, period = 'FY') => `/api/financial/balance/${symbol}?period=${period}`,
    CASHFLOW: (symbol, period = 'FY') => `/api/financial/cashflow/${symbol}?period=${period}`,
    TOP_COMPANIES: '/api/hometop/top-companies',
  },
  
  // 添加用户活动相关API
  USER_ACTIVITY: {
    TRACK: '/api/user-activities'
  },
};

// 辅助函数：构建完整URL
export const buildUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

export default API_CONFIG; 